import { render, staticRenderFns } from "./role-page.vue?vue&type=template&id=24d50482"
import script from "./role-page.vue?vue&type=script&lang=js"
export * from "./role-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports